$(window).on("load", function () {
  const prevArrow = `
    <div class="preArrow">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <path d="M12 2C17.5229 2 22 6.47713 22 12C22 17.5227 17.5229 22 12 22C6.47713 22 2 17.5227 2 12C2 6.47713 6.47713 2 12 2ZM8.9528 12.6773C9.00153 12.726 9.055 12.7672 9.11067 12.803L12.8637 16.556C13.0459 16.7384 13.2849 16.8295 13.5238 16.8295C13.7627 16.8295 14.0015 16.7384 14.1839 16.556C14.5486 16.1913 14.5486 15.6 14.1839 15.2355L10.95 12.0011L14.1677 8.7834C14.5323 8.41853 14.5323 7.8274 14.1677 7.46287C13.803 7.0982 13.2118 7.0984 12.8471 7.46267L9.11073 11.1989C9.05507 11.2347 9.0016 11.2758 8.95307 11.3246C8.76667 11.511 8.67673 11.7565 8.68093 12.001C8.67653 12.2453 8.76627 12.4907 8.9528 12.6773Z" fill="#C1C1C1"/>
      </svg>
    </div>
  `;
  const nextArrow = `
    <div class="nextArrow">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
        <g clip-path="url(#clip0_818_5807)">
        <path d="M12 2C6.47713 2 2 6.47713 2 12C2 17.5227 6.47713 22 12 22C17.5229 22 22 17.5227 22 12C22 6.47713 17.5229 2 12 2ZM15.0472 12.6773C14.9985 12.726 14.945 12.7672 14.8893 12.803L11.1363 16.556C10.9541 16.7384 10.7151 16.8295 10.4762 16.8295C10.2373 16.8295 9.99847 16.7384 9.81607 16.556C9.4514 16.1913 9.4514 15.6 9.81607 15.2355L13.05 12.0011L9.83233 8.7834C9.46767 8.41853 9.46767 7.8274 9.83233 7.46287C10.197 7.0982 10.7882 7.0984 11.1529 7.46267L14.8893 11.1989C14.9449 11.2347 14.9984 11.2758 15.0469 11.3246C15.2333 11.511 15.3233 11.7565 15.3191 12.001C15.3235 12.2453 15.2337 12.4907 15.0472 12.6773Z" fill="#C1C1C1"/>
        </g>
        <defs>
        <clipPath id="clip0_818_5807">
        <rect width="20" height="20" fill="white" transform="translate(2 2)"/>
        </clipPath>
        </defs>
      </svg>
    </div>
  `;

  $(".slider-for").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    fade: true,
    dots: false,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 5000,
    useTransform: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          dots: true,
        },
      },
    ],
  });

  $(".slider-nav").slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: ".slider-for",
    dots: false,
    focusOnSelect: true,
    prevArrow: prevArrow,
    nextArrow: nextArrow,
    autoplay: false,
    useTransform: false,
    centerMode: true,
    draggable: true,
    infinite: true,
  });

  $(".slide-review").slick({
    adaptiveHeight: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 5000,
    prevArrow: $('#preArrow'),
    nextArrow: $('#nextArrow'),
    appendDots: $(".slide-nav-review .dot"),
    useTransform: false,
    responsive: [
      {
        breakpoint: 1120,
        settings: {
          dots: true,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 900,
        settings: {
          dots: true,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 700,
        settings: {
          dots: true,
          slidesToShow: 1,
        },
      },
    ],
  });

  if ($(window).width() < 798) {
    $(".slide-feature").slick({
      adaptiveHeight: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      prevArrow: $('#preArrow-feature'),
      nextArrow: $('#nextArrow-feature'),
      appendDots: $(".slide-nav-feature .dot"),
      autoplay: true,
      autoplaySpeed: 5000,
      useTransform: false,
    });
  }

  $(".discount-columns-section .image-placeholder").css("display", "none");
  $(".discount-columns-section .slider-for").fadeIn();
  $(".discount-columns-section .slider-nav").fadeIn();
  $(".discount-columns-section .tag").fadeIn();

  $(".customer-review-section-page .slide-review").fadeIn();
});

function checkMainCarouselCustomall() {
  var interval = setInterval(() => {
    const mainCarouselWrap = document.getElementById("main-carousel");
    if (mainCarouselWrap) {
      clearInterval(interval);
      const delta2 = 6;
      let startX;
      let startY;
      mainCarouselWrap.addEventListener('mousedown', function (event) {
        startX = event.pageX;
        startY = event.pageY;
      });
    
      mainCarouselWrap.addEventListener('mouseup', function (event) {
        const diffX = Math.abs(event.pageX - startX);
        const diffY = Math.abs(event.pageY - startY);
    
        if (diffX < delta2 && diffY < delta2) {
          // Click!
          if ($(event.target).find('.video_img_link').length) {
            $(event.target).find('.video_img_link').click();
          }
        }
      });
    }
  }, 500)
}

$(document).ready(function () {
  $(".q-a:nth-child(1) .svg_q .arrow").css("transform", "rotate(180deg)");
  $(".q-a .svg_q").click(function () {
    if ($(this).parent().find(".all_a").hasClass("active")) {
      $(this).parent().find(".all_a").removeClass("active");

      $(this).find(".arrow").css("transform", "rotate(0deg)");
    } else {
      $(".q-a").find(".all_a").removeClass("active");
      $(this).parent().find(".all_a").addClass("active");

      $(".q-a .svg_q").find(".arrow").css("transform", "rotate(0deg)");
      $(this).find(".arrow").css("transform", "rotate(180deg)");
    }
  });

  checkMainCarouselCustomall();
  
  $(document).on("click",".video_img_link",function(e){
    e.preventDefault();
    const videoId = $(this).attr('data-video-id');
    let $popup = $(`.yt-iframe-modal.yt-video-${ videoId }`);
    const $iframe = $popup.find('iframe');
    $popup.addClass('show-modal');
    $iframe[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');

    $(`.yt-iframe-modal.yt-video-${ videoId }.show-modal, .yt-iframe-modal.yt-video-${ videoId } .close-button`).click(function(e) {
      $(`.yt-iframe-modal.yt-video-${ videoId }.show-modal, .yt-iframe-modal.yt-video-${ videoId } .close-button`).off('click');
      $popup.removeClass('show-modal');
      $iframe[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
    })
  });
});